import _ from 'lodash';
export default {
    props: {
        period: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        dependant: {
            type: Number,
            default: null,
        },
    },
    data() {
        // Always start with income in NET
        return {
            incomeType: 'net',
        };
    },
    computed: {
        innerPeriod() {
            return _.cloneDeep(this.period);
        },
        userValue: {
            get() {
                return this.innerPeriod[`${this.innerPeriod.pensionIncomeType}PensionIncome`];
            },
            set(value) {
                this.innerPeriod[`${this.innerPeriod.pensionIncomeType}PensionIncome`] = value;
                this.update();
            },
        },
        pensionType: {
            get() {
                return this.innerPeriod.pensionIncomeType;
            },
            set(value) {
                this.innerPeriod[`${value}PensionIncome`] = this.userValue;
                this.innerPeriod.pensionIncomeType = value;
                this.update();
            },
        },
        userIncomeType: {
            get() {
                return this.incomeType;
            },
            set(value) {
                this.incomeType = value;
                this.userIncomeValue = this.innerPeriod[`${this.incomeType}Income`];
            },
        },
        userIncomeValue: {
            get() {
                return this.innerPeriod[`${this.incomeType}Income`];
            },
            set(value) {
                this.innerPeriod[`${this.incomeType}Income`] = value;
                this.update();
            },
        },
    },
    methods: {
        update() {
            this.$emit('update', {
                index: this.index,
                period: this.innerPeriod,
                dependant: this.dependant,
            });
        },
    },
};



// WEBPACK FOOTER //
// ./src/pages/fatal-accident-claims/dependency/steps/dependency-on-income/income-period.mixin.js